import React from 'react'
import { ErrorMessage, Field } from 'formik'
import { Box, Typography, Icon, RadioGroup } from '@mui/material'
import AdxFormControlLabel from 'components/custom/AdxFormControlLabel'
import AdxRadioButton from 'components/custom/AdxRadioButton'
import AdxErrorMessage from 'components/custom/AdxErrorMessage'
import AdxInfoIcon from 'components/custom/AdxInfoIcon'

const PolicyAccrualOption = ({ formikBag }) => {
  const { values, setFieldValue } = formikBag
  return (
    <Box display="flex" flexDirection="column" rowGap={2}>
      <Box display="flex" alignItems="center" columnGap={1}>
        <Typography variant="body1" color="dark-text.main">
          Accrual Option
        </Typography>
        <AdxInfoIcon
          sx={{ ml: 2 }}
          toolTipTitle={
            'Select how leave will be accrued: full amount upfront, prorated annually, or monthly'
          }
        />
      </Box>
      <RadioGroup
        sx={{ width: '100%' }}
        name="accrual_type"
        value={values.accrual_type}
        onChange={(event) => {
          if (event.currentTarget.value !== 3) {
            setFieldValue('accrual_happen', null)
          }
          setFieldValue('accrual_type', Number(event.currentTarget.value))
        }}
      >
        <AdxFormControlLabel
          type="no-fill"
          selected={values.accrual_type}
          value={1}
          control={<Field as={AdxRadioButton} />}
          label="Full Amount"
          description="Full proportion of the leave amount given to employees"
        />
        <AdxFormControlLabel
          type="no-fill"
          selected={values.accrual_type}
          value={2}
          disabled={values.cycle_period === 'monthly'}
          control={<Field as={AdxRadioButton} />}
          label="Full Amount Prorate"
          description="Full amount will be accrued on a prorated basis"
        />
        <AdxFormControlLabel
          type="no-fill"
          selected={values.accrual_type}
          value={3}
          disabled={values.cycle_period === 'monthly'}
          control={<Field as={AdxRadioButton} />}
          label={
            <Box display="flex" alignItems="center" columnGap={2}>
              <Typography>Prorate</Typography>
              {/* <Typography color="light-gray-text.main">
                (1.33 days accrued per month)
              </Typography> */}
            </Box>
          }
          description="A proportion of the leave amount accrued by employees every month"
        />
      </RadioGroup>
      <ErrorMessage name="accrual_type" component={AdxErrorMessage} />
      {values.accrual_type === 3 && (
        <Box ml={8}>
          <Typography variant="body1" color="dark-text.main">
            Accrual Happens at
          </Typography>
          <RadioGroup
            sx={{ width: '100%' }}
            name="accrual_happen"
            value={values.accrual_happen}
            onChange={(event) => {
              setFieldValue('accrual_happen', event.currentTarget.value)
            }}
          >
            <AdxFormControlLabel
              type="no-fill"
              selected={values.accrual_happen}
              value="start_month"
              control={<Field as={AdxRadioButton} />}
              label="Beginning of the month"
            />
            <AdxFormControlLabel
              type="no-fill"
              selected={values.accrual_happen}
              value="end_month"
              control={<Field as={AdxRadioButton} />}
              label="End of the month"
            />
          </RadioGroup>
          <ErrorMessage name="accrual_happen" component={AdxErrorMessage} />
        </Box>
      )}
    </Box>
  )
}

export default PolicyAccrualOption
